import React from 'react';
import { Outlet } from 'react-router-dom';


function resumeStatsMain() {
    return (
        <div>
            <Outlet/>
        </div>
      );
}

export default resumeStatsMain;